import { client } from "api";

export type DeleteUserRequest = { userId: string };

export type DeleteUserResponse = string;

export const deleteUser = (request: DeleteUserRequest): Promise<DeleteUserResponse> =>
  client.delete<DeleteUserResponse>(`/user/${request.userId}`).then((res) => res.data);
